/**
 * DownloadCard - Grid card for My Downloads tab
 */
import { useState } from "react";
import { ImageOff, ShieldCheck, Calendar } from "lucide-react";
import { RedownloadButton } from "./RedownloadButton";

export function DownloadCard({ download }) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  const thumbnailUrl = download.secure_url
    ? download.secure_url.replace("/upload/", "/upload/c_fill,w_400,h_300,q_auto,f_auto/")
    : null;

  const formattedDate = new Date(download.timestamp).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

  const formattedTime = new Date(download.timestamp).toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div
      className="group relative rounded-lg overflow-hidden bg-white border border-slate-200 shadow-[0_2px_8px_rgba(0,0,0,0.04)] hover:shadow-[0_4px_16px_rgba(0,0,0,0.1)] transition-all duration-300"
      data-testid={`download-card-${download.public_id}`}
    >
      {/* Thumbnail */}
      <div className="aspect-[4/3] relative bg-slate-100">
        {!loaded && !error && thumbnailUrl && (
          <div className="absolute inset-0 flex items-center justify-center bg-slate-100">
            <div className="w-6 h-6 border-2 border-slate-300 border-t-slate-600 rounded-full animate-spin" />
          </div>
        )}
        {error || !thumbnailUrl ? (
          <div className="absolute inset-0 flex flex-col items-center justify-center bg-slate-100 text-slate-400">
            <ImageOff className="h-8 w-8 mb-1" />
            <span className="text-xs">Image unavailable</span>
          </div>
        ) : (
          <img
            src={thumbnailUrl}
            alt={download.dish_name}
            loading="lazy"
            onLoad={() => setLoaded(true)}
            onError={() => setError(true)}
            className={`w-full h-full object-cover transition-all duration-500 ${
              loaded ? "opacity-100" : "opacity-0"
            }`}
            draggable={false}
            style={{ userSelect: "none", WebkitUserSelect: "none" }}
          />
        )}
        {/* Downloaded badge */}
        <div className="absolute top-2 left-2 z-10">
          <span className="inline-flex items-center gap-1 px-2 py-1 rounded-md text-[11px] font-medium bg-emerald-500/90 text-white backdrop-blur-sm">
            <ShieldCheck className="h-3 w-3" />
            Downloaded
          </span>
        </div>
      </div>

      {/* Card content */}
      <div className="p-3">
        <p
          className="text-sm font-medium text-[#09090B] truncate mb-1"
          title={download.dish_name}
        >
          {download.dish_name}
        </p>
        <p className="text-[11px] text-slate-400 mb-3 flex items-center gap-1">
          <Calendar className="h-3 w-3" />
          {formattedDate} at {formattedTime}
        </p>
        <RedownloadButton
          publicId={download.public_id}
          dishName={download.dish_name}
          variant="full"
        />
      </div>
    </div>
  );
}
